import * as React from 'react';

import { OAPClasses } from './OAPClasses';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { BasePopupMenuIcon } from '../BasePopupMenuIcon';
import { OAPActions } from '../../../actions/OAPActions';
import { BasePopupMenuTitleSetting } from '../BasePopupMenuHeader';
import { OAPLevel } from '../../../stores/OAPStore';
import { BasePopupMenuContent } from '../BasePopupMenuContent';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

export class OAPProperties extends OAPClasses {
    public render(): JSX.Element {
        // 2nd level
        return (
            <BasePopupMenuContent
                transform={true}
                defaultValue={null}
                flagPosition={this.props.position.flagPosition}
                open={this.props.showEditor}
                options={this.options()}
                title={this.title()}
            />
        );
    }

    protected classFilter = (value: core.prop.Property): boolean => {
        return (
            this.props.selectedClass == null ||
            utils.string.isNullOrEmpty(this.props.selectedClass.key) ||
            (value.class === this.props.selectedClass.key)
        );
    };

    protected options = (): Array<SelectBoxOption> => {
        if (this.props.properties != null && this.props.properties.length > 0) {
            return this.props.properties.filter(this.classFilter).map((property, index) => {
                let className: string = '';
                const propertyValue: core.prop.PropertyValue | null = property.getValue();
                const extraButtons: Array<JSX.Element> = [];
                if (propertyValue != null && !utils.string.isNullOrEmpty(propertyValue.largeIcon)) {
                    extraButtons.push(<BasePopupMenuIcon src={propertyValue.largeIcon} key="icon"/>);
                } else if (propertyValue != null && !utils.string.isNullOrEmpty(propertyValue.smallIcon)) {
                    extraButtons.push(<BasePopupMenuIcon src={propertyValue.smallIcon} key="icon"/>);
                } else {
                    className = ' egr-select-option-no-icon';
                }

                if (propertyValue != null) {
                    extraButtons.push(
                        <span key="label" style={property.editable ? {color: '#95c11f'} : undefined}>
                            &nbsp;{propertyValue.text || property.getValueAsString()}
                        </span>
                    );
                }

                if (!property.editable) {
                    return {
                        name: OAPActions.getName(property),
                        value: index + '-o',
                        className: 'egr-select-disabled' + className,
                        extraButtons
                    };
                }

                return {
                    name: OAPActions.getName(property),
                    value: index + '-o',
                    className: 'egr-select-option-arrow' + className,
                    callback: () => {
                        OAPActions.setSelectedProperty(property);
                    },
                    extraButtons
                };
            });
        }

        return [];
    };

    protected title = (): BasePopupMenuTitleSetting => {
        if (utils.string.isNullOrEmpty(this.props.title)) {
            return {label: ''};
        }

        if (this.props.startLevel < OAPLevel.Properties) {
            return {label: this.props.title, className: 'egr-select-option-header-back', callback: () => {
                OAPActions.setSelectedClass(null);
            }};
        }

        return {label: this.props.title, className: '', callback: () => {
            OAPActions.hideDialog();
        }};
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPProperties.tsx